var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUploadDraggingFile(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44 28V23.5958C44 18.3311 44 15.6987 42.4611 13.9877C42.3195 13.8303 42.1697 13.6805 42.0123 13.5389C40.3013 12 37.6689 12 32.4042 12H31.6569C29.3495 12 28.1958 12 27.1207 11.6936C26.5301 11.5252 25.9609 11.2894 25.4242 10.9909C24.4473 10.4473 23.6316 9.63156 22 8L20.8995 6.8995C20.3527 6.35265 20.0792 6.07923 19.7919 5.84103C18.553 4.81407 17.0333 4.18457 15.4311 4.03475C15.0595 4 14.6729 4 13.8995 4C12.1344 4 11.2519 4 10.5168 4.1387C7.28062 4.74928 4.74928 7.28062 4.1387 10.5168C4 11.2519 4 12.1344 4 13.8995V25.3333L4.20299 36C4.45875 38.6002 5.03678 40.3505 6.34315 41.6569C8.68629 44 12.4575 44 20 44H28C35.5425 44 39.3137 44 41.6569 41.6569C44 39.3137 44 35.5425 44 28Z",
    stroke: "#081E54",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6665 32C16.6665 22.6274 16.6665 25.3726 16.6665 16M16.6665 16L10.6665 22M16.6665 16L22.6665 22",
    stroke: "#A020FF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadDraggingFile);
export default __webpack_public_path__ + "static/media/UploadDraggingFile.7ac732bc5b1121cb351cae0a610dbe46.svg";
export { ForwardRef as ReactComponent };